import React, { useState } from "react";
import "../../assets/css/privacy_consent_modal.scss";

const GeulpicThirdPartyModal = ({ isOpen, onClose, onNext }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  if (!isOpen) return null;

  const handleNext = () => {
    if (!isAgreed) {
      alert("제3자 개인정보수집 제공에 동의해주세요.");
      return;
    }
    onNext();
  };

  const handleClose = () => {
    setIsAgreed(false);
    onClose();
  };

  return (
    <div className="privacy-modal-overlay" onClick={handleClose}>
      <div
        className="privacy-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="privacy-modal-header">
          <h2 className="privacy-modal-title">글픽</h2>
          <button className="privacy-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        <div className="privacy-modal-body">
          <h3 className="privacy-section-title">
            글픽 개인정보 수집 및 이용약관
          </h3>

          <div className="privacy-content-box">
            <h4>다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</h4>
            <br />

            <p>
              1. 개인정보를 제공받는 자 : (주)위고컴퍼니
              <br />
              2. 제공받는 자의 개인정보 이용목적 : 이벤트 공동개최 등 업무제휴
              <br />
              3. 제공하는 개인정보 항목 : 성명, 배송지 주소, 휴대폰번호
              <br />
              4. 제공받는 자의 보유 및 이용기간 : 구독 해지 또는 회원탈퇴 및
              개인정보 제3자 제공 철회 시까지
            </p>
          </div>

          <div className="privacy-agreement">
            <label className="privacy-checkbox-label">
              <input
                type="checkbox"
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              />
              <span className="privacy-checkbox-text">
                (필수) "제 3자 개인정보수집 제공 "에 동의합니다.
              </span>
            </label>
          </div>
        </div>

        <div className="privacy-modal-footer">
          <button className="privacy-next-button" onClick={handleNext}>
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeulpicThirdPartyModal;
